import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Link } from "gatsby";
import Drawer from "../../Drawer";
import styles from "./style.module.scss";

const logo = require("../../../images/greek-dressing-logo-no-text.svg");

class MobileNav extends Component {
  componentWillMount() {
    this.resetComponent();
  }

  resetComponent = () => {
    this.setState({
      active: false
    });
  };

  toggleActiveClass = () => {
    const currentState = this.state.active;
    this.setState({ active: !currentState });
  };

  handleClick = () => {
    this.resetComponent();
  };

  render() {
    const { routes } = this.props;
    const { active } = this.state;

    const createLink = route => (
      <Link
        className={styles.link}
        to={route.to}
        onClick={this.handleClick}
        key={route.title}
      >
        {route.title}
      </Link>
    );

    const MobileMenuToggle = () => (
      <div className={styles.dropdownTriggerContainer}>
        <li
          className={cx({
            [styles.link]: true,
            [styles.dropdownTrigger]: true
          })}
          onClick={this.toggleActiveClass}
        >
          Menu
        </li>
      </div>
    );

    const Logo = () => (
      <img
        src={logo}
        className={styles.logo}
        alt="Greek Dressing Logo"
        title="Greek Dressing Logo"
      />
    );

    const NewOrderButton = () => (
      <div
        className={cx({
          [styles.menuItems]: true,
          [styles.newOrderButton]: true
        })}
      >
        {createLink({
          to: "/new-order",
          title: "New order"
        })}
      </div>
    );

    return (
      <>
        <div className={styles.menu}>
          <MobileMenuToggle />
          <Link to="/">
            <Logo />
          </Link>
          <NewOrderButton />
        </div>
        <Drawer handleClose={this.resetComponent} open={active} fullScreen>
          <div className={styles.dropdown}>
            {routes.map(route => createLink(route))}
            <a
              href="https://shop.greekdressing.us/collections/all-products"
              className={styles.link}
            >
              Shop Retail
            </a>
            {createLink({ to: "/new-order", title: "Custom order" })}
          </div>
        </Drawer>
      </>
    );
  }
}

MobileNav.propTypes = {
  routes: PropTypes.array.isRequired
};

export default MobileNav;
